import { useApolloClient } from "@apollo/client/react/hooks"

import { DeleteResponseTypename, MutationTypename } from "shared/api/types"
import { useEvent } from "shared/lib/useEvent"
import { ApolloFetchPolicy } from "shared/types/ApolloFetchPolicy"
import { ProjectsAPIType } from "shared/types/Project"

import { evictAttachment } from "entities/attachments/api/evictAttachment"
import {
  DeleteAttachmentMutationVariables,
  useDeleteAttachmentMutation
} from "entities/attachments/graphql/mutations.generated"
import { useAttachmentsLazyQuery } from "entities/attachments/graphql/project-attachments.queries.generated"

export function useDeleteProjectAttachment() {
  const { cache: apolloCache } = useApolloClient()
  const [fetchAttachments] = useAttachmentsLazyQuery()
  const [mutate, rest] = useDeleteAttachmentMutation()

  const deleteProjectAttachment = useEvent(
    (variables: DeleteAttachmentMutationVariables, projectID: string) => {
      evictAttachment(variables.id, apolloCache)

      return mutate({
        variables,
        optimisticResponse: {
          __typename: MutationTypename,
          attachment: { __typename: DeleteResponseTypename, success: true }
        },
        onError: () => {
          fetchAttachments({
            variables: { id: projectID, type: ProjectsAPIType },
            fetchPolicy: ApolloFetchPolicy.NETWORK_ONLY
          })
        }
      })
    }
  )
  return {
    deleteProjectAttachment,
    ...rest
  }
}
